module.exports = __webpack_public_path__ + "img/7.fe6282b5.png";